<script>
import { VTextField, VTextarea, VSelect, VCheckbox } from 'vuetify/lib'
import DatePicker from './DatePicker'
import TimePicker from './TimePicker'
export default {
  name: 'UniversalInput',
  components: {
    VCheckbox,
    VTextField,
    VTextarea,
    DatePicker,
    TimePicker,
    VSelect
  },
  render (h) {
    const self = this
    return h(self.nodeName, {
      props: {
        required: self.required,
        label: self.label,
        hint: self.hint,
        value: self.value1,
        typeConfig: self.type,
        prefix: self.prefix,
        rules: self.rules,
        items: self.items,
        itemText: self.itemText,
        rows: self.rows,
        itemValue: self.itemValue,
        prependIcon: self.prependIcon,
        returnObject: self.returnObject,
        allowedDates: self.allowedDates,
        outlined: true
      },
      on: {
        input: function (value) {
          // console.log('nuiversal input value update', value)
          self.updateValue(value)
          self.update()
        },
        change: function (value) {
          if (value) {
            self.updateValue(value)
          } else {
            self.updateValue(false)
          }
          self.update()
        }
      }
    })
  },
  created () {
    if (this.isCheckbox) {
      this.value1 = []
    }
  },
  mounted () {
    // console.log('this.label,this.value', this.label, this.value)
    // console.log('this.config', this.config)
    // const defaultValue = this.value || this.config.defaultValue
    if (typeof this.config.defaultValue !== 'undefined') {
      console.log('this.label,defaultValue', this.label, this.config.defaultValue)
      this.updateValue(this.config.defaultValue)
    } else {
      this.updateValue(this.value)
    }
    this.update()
    this.disabled = this.disabledControl
  },
  data () {
    return {
      defaultType: {
        name: 'text'
      },
      nodeNames: {
        checkbox: 'v-checkbox',
        text: 'v-text-field',
        textarea: 'v-textarea',
        datepicker: 'date-picker',
        timepicker: 'time-picker',
        select: 'v-select',
        file: 'v-file-input'
      },

      value1: null,
      value2: null,

      defaultDateFormat: 'yyyy/MM/dd',
      defaultTimeFormat: 'HH:mm:ss',
      defaultDateTimeSeparator: ' ',

      disabled: false
    }
  },
  methods: {
    updateValue (newvalue) {
      this.value1 = newvalue
      // console.log('this.value1', this.value1)
    },
    update () {
      this.$emit('input', this.returnValue)
      this.$emit('update')
    }
  },
  computed: {
    label () {
      if (this.config.label) {
        if (this.config.label.toLowerCase().startsWith('message.')) {
          return this.$t(this.config.label)
        }
        return this.config.label
      }
      return ''
    },
    hint () {
      if (this.config.hint) {
        if (this.config.hint.toLowerCase().startsWith('message.')) {
          return this.$t(this.config.hint)
        }
        return this.config.hint
      }
      return ''
    },
    returnObject () {
      return this.type.returnObject || false
    },
    allowedDates () {
      return this.type.allowedDates || null
    },
    rows () {
      return this.type.rows || 5
    },
    // + this.$i18n.locale
    switchLocal () {
      return this.type.switchLocal || false
    },
    storeName () {
      return this.type.storeName || ''
    },
    items () {
      return this.type.items || this.$store.getters[this.storeName] || []
    },
    itemText () {
      let itemText = this.type.itemText || 'label'
      if (this.switchLocal) {
        itemText += this.$i18n.locale
      }
      // console.log('itemText', itemText)
      return itemText
    },
    itemValue () {
      return this.type.itemValue || 'id'
    },
    required () {
      return this.type.required || false
    },
    rules () {
      return this.type.rules || []
    },
    prefix () {
      return this.type.prefix || ''
    },
    prependIcon () {
      return this.type.prependIcon || ''
    },
    options () {
      return this.type.options || []
    },
    nodeName () {
      return this.nodeNames[this.typeName]
    },
    dateTimeSeparator () {
      return this.type.dateTimeSeparator || this.defaultDateTimeSeparator
    },
    isText () {
      return this.typeName === 'text'
    },
    isTextarea () {
      return this.typeName === 'textarea'
    },
    isSelect () {
      return this.typeName === 'select'
    },
    isDate () {
      return this.typeName === 'date'
    },
    isDateTime () {
      return this.typeName === 'datetime'
    },
    isTime () {
      return this.typeName === 'time'
    },
    isSwitch () {
      return this.typeName === 'switch'
    },
    isCheckbox () {
      return this.typeName === 'checkbox'
    },
    isRadio () {
      return this.typeName === 'radio'
    },
    isTextInput () {
      return this.isText || this.isTextarea
    },
    isInDateTime () {
      return this.isDate || this.isTime || this.isDateTime
    },
    dateOrTimeColSpan () {
      return (this.isDateTime) ? 11 : 24
    },
    typeName () {
      if (this.type) {
        if (this.type.name) {
          return this.type.name
        }
        return this.defaultType.name
      }
      return null
    },
    type () {
      return (this.config.type) || this.defaultType
    },
    returnValue () {
      // if (this.isText || this.isSelect || this.isSwitch || this.isCheckbox || this.isRadio) {
      //   return this.value1
      // } else if (this.isDate) {
      //   return this.dateValue
      // } else if (this.isTime) {
      //   return this.timeValue
      // } else if (this.isDateTime) {
      //   return {
      //     date: this.dateValue,
      //     time: this.timeValue,
      //     datetime: this.dateValue + this.defaultDateTimeSeparator + this.timeValue
      //   }
      // }
      return this.value1
    }
  },
  props: {
    value: {},
    config: {
      type: Object,
      default: () => ({
        // name: 'mock',
        // label: 'mock label 1',
        // type: { 'name': 'text' }
      })
    },
    disabledControl: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      // console.log('newvalue', newvalue)
      this.updateValue(newvalue)
      this.update()
      if (this.type.customEvent) {
        this.$bus.$emit(this.type.customEvent, newvalue, oldvalue)
      }
    },
    disabledControl (newDisabledControl) {
      this.disabled = newDisabledControl
    }
    // ,
    // inputConfig (newInputConfig) {
    //   console.log('new inpute config in dynamic input', newInputConfig)
    //   // console.log('newvalue', newvalue)
    //   if (newInputConfig.type.disabled) {
    //     this.disabled = true
    //   }
    //   this.disabled = false
    // }
  }
}
</script>

<style>
</style>
